<template>
  <div class="container searchresult farsi">
    <app-header @filter="localFilter=$event" @sort="localSort=$event"></app-header>
    <a @click="showFilters=!showFilters" class="filterHead colorLiveGray60">فیلتر</a>
    <div class="filterHeadLeft">
      <span
        class="backBtn"
      >{{getBtnText(`${$store.state.flight.data.tripType}${departureReturn()}`)}}</span>
      <span class="backBtn">-</span>
      <span class="resultHead colorLiveGray60">
        نتایج :‌
        <span>{{elementLength}}</span> بلیط
      </span>
      <div class="sortBy colorLiveGray60"></div>
      <app-mediumswitch
        :propsClass="'ticketFilterSwitch'"
        @switch="localSort.sortBy = $event"
        :default="localSort.sortBy"
        :config="{right:{text:'قیمت',value:'price'},left:{text:'زمان',value:'time'}}"
      ></app-mediumswitch>
      <div class="filter-tartib" @click="[localSort.sortAscending=!localSort.sortAscending]">
        <div class="ascending" :class="{hide:localSort.sortAscending}">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter>
              <rect width="32" height="32" rx="16" fill="black" fill-opacity="0.04" />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.713 10.3071C17.9932 10.191 18.3158 10.2552 18.5303 10.4697L21.5303 13.4697C21.8232 13.7626 21.8232 14.2375 21.5303 14.5304C21.2374 14.8232 20.7626 14.8232 20.4697 14.5304L18.75 12.8107V20C18.75 20.4142 18.4142 20.75 18 20.75C17.5858 20.75 17.25 20.4142 17.25 20V11C17.25 10.6967 17.4327 10.4232 17.713 10.3071Z"
              fill="#919499"
            />
            <path
              opacity="0.5"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.25 13C9.25 12.5858 9.58579 12.25 10 12.25L15.75 12.25V13.75L10 13.75C9.58579 13.75 9.25 13.4142 9.25 13ZM11.25 16C11.25 15.5858 11.5858 15.25 12 15.25H15.75V16.75H12C11.5858 16.75 11.25 16.4142 11.25 16ZM13.25 19C13.25 18.5858 13.5858 18.25 14 18.25H15.75V19.75H14C13.5858 19.75 13.25 19.4142 13.25 19Z"
              fill="#919499"
            />
            <defs>
              <filter
                id="filter0_i"
                x="0"
                y="0"
                width="32"
                height="32"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
            </defs>
          </svg>
        </div>
        <div class="descending" :class="{hide:!localSort.sortAscending}">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter>
              <rect width="32" height="32" rx="16" fill="black" fill-opacity="0.04" />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.713 20.6929C17.9932 20.809 18.3158 20.7448 18.5303 20.5303L21.5303 17.5303C21.8232 17.2374 21.8232 16.7626 21.5303 16.4697C21.2374 16.1768 20.7626 16.1768 20.4697 16.4697L18.75 18.1893V11C18.75 10.5858 18.4142 10.25 18 10.25C17.5858 10.25 17.25 10.5858 17.25 11V20C17.25 20.3033 17.4327 20.5768 17.713 20.6929Z"
              fill="#919499"
            />
            <path
              opacity="0.5"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.25 19C9.25 19.4142 9.58579 19.75 10 19.75H15.75V18.25H10C9.58579 18.25 9.25 18.5858 9.25 19ZM11.25 16C11.25 16.4142 11.5858 16.75 12 16.75H15.75V15.25H12C11.5858 15.25 11.25 15.5858 11.25 16ZM13.25 13C13.25 13.4142 13.5858 13.75 14 13.75L15.75 13.75V12.25L14 12.25C13.5858 12.25 13.25 12.5858 13.25 13Z"
              fill="#919499"
            />
            <defs>
              <filter
                id="filter0_i"
                x="0"
                y="0"
                width="32"
                height="32"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
            </defs>
          </svg>
        </div>
        <span>ترتیب</span>
      </div>
    </div>
    <transition name="app-fade">
      <sidebar v-if="showFilters" @filter="localFilter = $event" :localFilter="localFilter"></sidebar>
    </transition>
    <flightlist
      @getElementsNumber="elementLength=$event"
      :localSort="localSort"
      @departureReturn="isDepartureOrReturn=$event"
      :localFilter="localFilter"
    ></flightlist>
  </div>
</template>

<script>
import mediumswitch from "../../../widgets/mediumswitch.vue";
import flightlist from "./flightlist.vue";
import sidebar from "./sidebar.vue";
import header from "./header.vue";
export default {
  data() {
    return {
      timeout: null,
      showFilters: false,
      elementLength: "0",
      localSort: {
        sortBy: "price",
        sortAscending: true,
      },
      isDepartureOrReturn: "departure",
      localFilter: {
        time: "all",
        seatClass: "allseats",
        charter: "allmodes",
      },
    };
  },
  methods: {
    getWidth() {
      return window.innerWidth;
    },
    getBtnText(trip) {
      switch (trip) {
        case "oneway":
          return "خرید بلیط یک طرفه";
        case "roundtripdeparture":
          return "خرید بلیط رفت";
        case "roundtripreturn":
          return "خرید بلیط برگشت";
      }
    },
    departureReturn() {
      switch (this.$store.state.flight.data.tripType) {
        case "oneway":
          return "";
        case "roundtrip":
          return this.isDepartureOrReturn;
      }
    },
    searchTimeout() {},
    searchAgain() {},
  },
  components: {
    flightlist,
    sidebar,
    "app-header": header,
    "app-mediumswitch": mediumswitch,
  },
  watch: {},
  mounted() {
    if (window.innerWidth > 768) {
      this.showFilters = true;
    } else {
      this.showFilters = false;
    }
    this.$store.state.loading = false;
    this.$store.state.flight.flights = [];
    if (!this.$store.state.flight.inProcess) {
      this.$router.push({ path: "/" });
    }
    this.$store.state.flight.currentDate = "departure";
    let self = this;
    this.timeout = setTimeout(() => {
      self.$store.dispatch(
        "tost",
        {
          success: "message",
          show: true,
          text: `زمان انتخاب از بین این نتایج جست‌وجو به پایان رسیده است. <br><a href="/flight" class="tostButton">دوباره جست‌وجو کن</a>`,
          time: 1000000,
        },
        { root: true }
      );
    }, 600000);
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
};
</script>

<style>
.backBtn {
  float: right;
  margin: 8px 0 8px 8px;
  font-size: 14px;
  color: #292931;
}
@media (max-width: 768px) {
  .backBtn {
    display: none;
  }
}
</style>
